export default "__VITE_ASSET__BlU3TO$j__"